import { render } from "./ClientVentasPedidoVer.vue?vue&type=template&id=7bfb8381&scoped=true"
import script from "./ClientVentasPedidoVer.vue?vue&type=script&lang=js"
export * from "./ClientVentasPedidoVer.vue?vue&type=script&lang=js"

import "./ClientVentasPedidoVer.vue?vue&type=style&index=0&id=7bfb8381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfb8381"]])

export default __exports__